import { FeaturedIconOutline } from "@unified-checkout/design-system";
import { Xmark } from "@unified-checkout/design-system/icons/index";
import type { IComponentError } from "@app/dashboard/types/shared/component-error";
import styles from "./component-error.module.scss";

export const ComponentError = ({ text }: IComponentError) => {
  return (
    <div className={styles["component-error"]}>
      <FeaturedIconOutline
        size="lg"
        color="error"
        icon={Xmark}
      />
      {text && <div className={styles["component-error__text"]}>{text}</div>}
    </div>
  )
};